import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Arrow from '../icons/Arrow';

import {
  Container,
  Header,
  HeaderInfoWrapper,
  Image,
  Title,
  MainInfo,
  Text,
  Content,
  ContentItemWrapper,
  ArrowWrapper,
  ContentWrapper,
} from './styles';

export const propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  post: PropTypes.string.isRequired,
  info: PropTypes.object,
};

class Person extends Component {
  static propTypes = {
    ...propTypes,
  };

  static defaultProps = {
    info: null,
  };

  state = {
    activeContent: false,
  };

  componentDidMount() {
    if (this.checkInfo()) {
      this.fullHeight = this.__panel.firstChild.offsetHeight;
    }
  }

  checkInfo = () => !!this.props.info;

  handleClick = () => this.setState(({ activeContent }) => ({ activeContent: !activeContent }));

  renderArrow = () => {
    const { activeContent } = this.state;

    return this.checkInfo() && (
      <ArrowWrapper active={activeContent}>
        <Arrow />
      </ArrowWrapper>
    );
  };

  renderPhone = () => {
    const { phone }  = this.props;

    if (phone) {
      return (
        <Text>{ phone }</Text>
      );
    }

    return null;
  };

  renderEmail = () => {
    const { email } = this.props;

    if (email) {
      return (
        <Text>{ email }</Text>
      );
    }

    return null;
  };

  renderHeader = () => (
    <Header onClick={this.handleClick}>
      <HeaderInfoWrapper>
        <Image src={this.props.image} />
        <div>
          <Title>{this.props.name}</Title>
          <MainInfo>{this.props.post}</MainInfo>
          {this.renderPhone()}
          {this.renderEmail()}
        </div>
      </HeaderInfoWrapper>
      {this.renderArrow()}
    </Header>
  );

  renderContentList = (title, list, key) => (
    <ContentItemWrapper key={key}>
      <Title content>{title}</Title>
      {list.map((item, i) => <Text key={i} content dangerouslySetInnerHTML={{ __html: item }} />)}
    </ContentItemWrapper>
  );

  renderContent = () => {
    const { info } = this.props;
    const { activeContent } = this.state;
    const keys = Object.keys(info);
    const height = activeContent ? this.fullHeight : 0;

    return (
      <ContentWrapper height={height} ref={c => this.__panel = c}>
        <Content>
          {keys.map(key => this.renderContentList(info[key].title, info[key].list, key))}
        </Content>
      </ContentWrapper>
    );
  };

  render() {
    return (
      <Container>
        {this.renderHeader()}
        {this.checkInfo() && this.renderContent()}
      </Container>
    );
  }
}

export default Person;
